import BaseView from "./utilities/baseView.js";
import Search from "./modules/ApartmentSearch/search.js";
import SearchFilters from "./modules/SearchFilters/index.js";
import SliderCounter from "./utilities/slider-counter.js";
import Selectpicker from "./utilities/selectpicker.js";
import Gallery from "./utilities/gallery.js";
import { tns } from "./../../../node_modules/tiny-slider/src/tiny-slider";
import ImgLazyLoader from "./utilities/imgLazyLoader.js";
import "leaflet";

class ApartmentsListView extends BaseView {
    sliders = document.querySelectorAll(".apartment-slider");
    textContainer = document.querySelector(".text");
    moreContainer = document.querySelector(".more");
    moreButton = document.getElementById("moreToggle");

    gallery = null;
    map = null;
    mapPointer = null;

    search = null;
    filters = null;
    sliderCounter = null;

    constructor() {
        super(apartmentListConfig);
        new Selectpicker();
        this.filters = new SearchFilters(
            searchFiltersConfig,
            this.notification,
            true
        );
        apartmentSearchConfig["settings"]["regionId"] = apartmentListConfig["settings"]["regionId"];
        apartmentSearchConfig["settings"]["cityId"] = apartmentListConfig["settings"]["cityId"];
        apartmentSearchConfig["settings"]["facilityId"] = apartmentListConfig["settings"]["facilityId"];
        this.search = new Search(
            apartmentSearchConfig,
            this.notification,
            this.loader,
            true,
            false,
            this.filters
        );
        this.sliderCounter = new SliderCounter();
        this.gallery = new Gallery(this.settings("gallery"));
        this.lazyLoader = new ImgLazyLoader(
            document.querySelector(".apartments-list-container")
        );
        this.bindSortButton();
        this.prepareMap();
        this.preparePhotosSliders();
        this.prepareShowMoreModule();
        this.prepareApartmentsLazyLoader();
        this.stickOnScroll();
//        this.toggleMore();
    }

    preparePhotosSliders = () => {
        this.sliders.forEach((slider) => {
            const tinySLider = tns({
                preventScrollOnTouch: "force",
                container: slider,
                items: 1,
                nav: false,
                mouseDrag: true,
                center: false,
                controls: true,
                swipeAngle: false,
                arrowKeys: true,
            });

            if (tinySLider !== undefined) {
                tinySLider.events.on("indexChanged", (data, eventName) => {
                    this.sliderCounter.add(data);
                });
            }
        });
    };

    prepareMap = () => {
        document.getElementById("map-container").style.height = "400px";
        document.getElementById("map-container").style.marginBottom = "10px";
        const lat = parseFloat(this.settings("mapMarker").lat);
        const long = parseFloat(this.settings("mapMarker").long);
        const icon = (this.mapPointer = L.icon({
            iconUrl: window.location.origin + "/Content/Images/sns_pointer.png",
            iconAnchor: [14, 47],
            iconSize: [28, 47],
            popupAnchor: [0, -47],
        }));

        this.map = L.map("map-container", {
            dragging: !L.Browser.mobile,
            tap: !L.Browser.mobile,
            scrollWheelZoom: true,
        }).setView([lat, long], 13);

        L.tileLayer("https://c.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution:
                'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            maxZoom: 18,
            id: "mapbox.streets",
        }).addTo(this.map);

        L.marker([lat, long], {
            icon: icon,
        }).addTo(this.map);

        const button = document.getElementById("mapTrigger");

        button.addEventListener("click", () => {
            window.modal.open("map");
            this.map.invalidateSize();
        });
    };

    prepareShowMoreModule = () => {
        this.moreButton.addEventListener("click", () => {
            this.toggleMore();
        });
    };

    toggleMore = () => {
        const { moreContainer, textContainer } = this;

        moreContainer.classList.toggle("open");
        textContainer.classList.toggle("open");

        if (!moreContainer.classList.contains('open')) {
            document.querySelector('#facility-description').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        }
    };

    bindSortButton = () => {
        const button = document.querySelector(".sorter");
        const sorterIcons = document.querySelector(".sorter__icons");

        button.addEventListener("click", () => {
            const sortType = sorterIcons.classList.contains("asc") ? "asc" : "desc";
            this.search.triggerSearchBySort(sortType);
        });
    };

    stickOnScroll = () => {
        const search = document.querySelector('.search-header');
        const filters = document.querySelector('.objects-filters-container');
        const stickyPoint = search.getBoundingClientRect().top;

        function stickyManage() {
            if (window.scrollY > stickyPoint) {
                search.classList.add('sticky');
                filters.classList.add('sticky');
            } else {
                search.classList.remove('sticky');
                filters.classList.remove('sticky');
            }
        }

        stickyManage();

        window.addEventListener('scroll', () => {
            stickyManage();
        });
    }

    prepareApartmentsLazyLoader = () => {
        const container = document.querySelector(".list-container");
        const objects = container.querySelectorAll(".apartment");
        const footer = document.querySelector('#facility-description');
        const toDisplay = [];

        objects.forEach((object, index) => {
            if (index > 5) {
                toDisplay.push(object.cloneNode(true));
                object.remove();
            }
        });

        window.addEventListener('scroll', () => {
            const footerRect = footer.getBoundingClientRect();

            if (window.innerHeight >= footerRect.top && toDisplay.length !== 0) {
                for (let index = 0; index < 3; index++) {
                    const object = toDisplay.shift();
                    if (object) {
                        container.appendChild(object);
                        this.lazyLoader.singleImageLoad(object.querySelector('.apartment-slider__item img'));
                    }
                }
            }
        });
    }
}

new ApartmentsListView();
